import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';

export interface SectionTab {
  /** The path segment, e.g. "boards". */
  value: string;
  label: string;
}

interface Props {
  /** Says what the tabs choose between, for screen readers. */
  label: string;
  tabs: SectionTab[];
  /** The tab shown now; an unknown value shows the first. */
  value: string;
  /** Where a tab's page lives, e.g. (tab) => `/admin/jobs/${tab}`. */
  to: (value: string) => string;
  /** Smaller, for the second row of tabs. */
  dense?: boolean;
}

/**
 * A row of tabs where each tab is a real link, so every view has its own
 * address, the back button walks between them, and a tab opens in a new tab.
 */
const SectionTabs: React.FC<Props> = ({ label, tabs, value, to, dense = false }) => {
  const current = tabs.some((tab) => tab.value === value) ? value : tabs[0]?.value;
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={current}
        aria-label={label}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={dense ? { minHeight: 40, '& .MuiTab-root': { minHeight: 40, py: 0.5, textTransform: 'none', fontWeight: 500 } } : undefined}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} component={RouterLink} to={to(tab.value)} />
        ))}
      </Tabs>
    </Box>
  );
};

export default SectionTabs;
